<template>
    <v-container class="pa-5" fluid>
        <page-title class="pb-3">
            Konfiguracje
        </page-title>
        <v-row>
            <v-col>
                <v-card>
                    <v-tabs
                        v-model="tabs"
                        vertical
                        background-color="grey lighten-4"
                    >
                        <v-tab>Magazyny</v-tab>
                        <v-tab>Doki</v-tab>
                        <v-tabs-items v-model="tabs">
                            <v-tab-item>
                                <v-card flat>
                                    <v-card-text>
                                        <StoresList />
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card flat>
                                    <v-card-text>
                                        <DocksList />
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import DocksList from './DocksList'
import StoresList from './StoresList'

export default {
    name: 'Configurations',
    components: {
        PageTitle,
        DocksList,
        StoresList
    },
    data() {
        return {
            tabs: null
        }
    },
}
</script>
